export * from './lib/trims-configuration-form';
